import { Injectable } from '@angular/core';
import { Feature, FeatureCollection, Point } from 'geojson';
import { Socket } from 'ngx-socket-io';
import { Tempo } from 'src/app/instant-analysis/models/tempo';
import { RainDuration } from '../../models/rain-duration';

@Injectable({
  providedIn: 'root'
})
export class QueryProgressService {

  /** 
   * Caminho que trata o disparo da consulta dos registros de chuva no intervalo de tempo. 
   */
  rainIntervalStartPath = 'rain-interval-start';

  /** 
   * Caminho usado para obter o progresso da consulta iniciada em rain-interval-start.
   */
  rainIntervalProgressPath = 'rain-interval-progress';

  /**
   * Caminho usado para obter o resultado da consulta iniciada em rain-interval-start.
   */
  rainIntervalResultPath = 'rain-interval-result';

  constructor(private socket: Socket) { }

  /**
   * Inicia a consulta de registros de chuva no intervalo de tempo selecionado.
   * 
   * @param startDateTime data inicial no formato YYYY-MM-DD hh:mm
   * @param endDateTime data final no formato YYYY-MM-DD hh:mm
   */
  public startRainIntervalQuery(startDateTime: string, endDateTime: string, completeness:number, dataSource:string[]) {
    this.socket.emit(this.rainIntervalStartPath, { startDateTime, endDateTime, completeness, dataSource});
  }

  /**
   * Obtém um ouvinte do progresso da consulta iniciada em startRainIntervalQuery.
   * 
   * @returns Ouvinte da porcentagem do progresso da consulta.
   */
  public getRainIntervalProgress() {
    return this.socket.fromEvent<number>(this.rainIntervalProgressPath);
  }

  /**
   * Obtém um ouvinte do resultado da consulta iniciada em startRainIntervalQuery.
   * 
   * @returns Ouvinte do resultado da consulta de chuvas no intervalo de tempo.
   */
  public getRainIntervalResults() {

    /**
     * Interface dos resultados da consulta de estatísticas das chuvas nas estações e bairros
     * no intervalo de tempo definido.
     */
    interface RainIntervalResults {

      /** Coleção na qual cada feature é uma estação com as estatísticas de chuva calculadas. */
      stationsStats: FeatureCollection<Point>;

      /** 
       * Coleção na qual cada feature é um bairro com as estatísticas de chuva interpoladas 
       * a partir das estações.
       */
      neighborhoodsStats: Feature<Point>[];

      /** Array [ tempo inicial, tempo final ] */
      timeRows: Tempo[];

      /** Durações das intensidades das chuvas na cidade como um todo, medidas em segundos. */
      cityRainDurationInSeconds: RainDuration;
    };

    /** Resposta da consulta */
    interface RainIntervalResponse {

      /** Indica se houve sucesso ou não. */
      success: boolean;

      /** Mensagem da resposta. */
      message: string;

      /** Dados da resposta. */
      data: RainIntervalResults;
    }

    return this.socket.fromEvent<RainIntervalResponse>(this.rainIntervalResultPath);
  }
}
